import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';

export function useBOM(projectId: string) {
  const [boms, setBoms] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!projectId) {
      setBoms([]);
      return;
    }

    const fetchBOMs = async () => {
      setIsLoading(true);
      setError(null);

      try {
        // For testing purpose, show all BOMs regardless of status
        const { data, error } = await supabase
          .from('boms')
          .select('id, name, version, status')
          .eq('project_id', projectId)
          .order('version', { ascending: false });

        if (error) throw error;
        setBoms(data || []);
      } catch (err) {
        console.error('Error fetching BOMs:', err);
        setError(err as Error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBOMs();
  }, [projectId]);

  return { boms, isLoading, error };
}
